import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SettingsPageComponent } from './settings-page/settings-page.component';
import { MaterialModule } from '../material/material.module';
import { SettingControlComponent } from './setting-control/setting-control.component';
import { ShipmentModule } from '../shipment/shipment.module';
import { CardEditComponent } from './card-edit/card-edit.component';
import { SharedModule } from '../shared/shared.module';
import { ReactiveFormsModule } from '@angular/forms';
import { AvatarUploadComponent } from './avatar-upload/avatar-upload.component';
import { ImageCropperModule } from 'ngx-image-cropper';
import { NavigationModule } from '../navigation/navigation.module';

@NgModule({
    imports: [
        CommonModule,
        MaterialModule,
        ShipmentModule,
        SharedModule,
        ReactiveFormsModule,
        ImageCropperModule,
        NavigationModule,
        SettingsPageComponent,
        SettingControlComponent,
        CardEditComponent,
        AvatarUploadComponent
    ]
})
export class SettingsModule {
}
